import {
  Cancel01Icon,
  FileSyncIcon,
  SentIcon
} from "@hugeicons-pro/core-stroke-rounded";
import {
  IconButton,
  IconButtonSize,
  CheckboxCard,
  Button,
  ButtonVariant
} from "shared/components";
import { OptionLabel } from "./slices/components/OptionLabel";
import { ReverifyFlows } from "./types";

interface Props {
  onClose: () => void;
  setCurrentFlow: (step: ReverifyFlows) => void;
  selectedReverifyOption:
    | ReverifyFlows.ReVerifyHere
    | ReverifyFlows.SendRequest;
  setSelectedReverifyOption: (
    value: ReverifyFlows.ReVerifyHere | ReverifyFlows.SendRequest
  ) => void;
}

export const SelectVerificationFlow = ({
  onClose,
  setCurrentFlow,
  selectedReverifyOption,
  setSelectedReverifyOption
}: Props) => (
  <div className="flex flex-col h-full">
    <header className="p-6 border-b border-alpha-100">
      <h1 className="text-xl text-content-1000 font-bold mb-1 relative">
        Select verification type
        <IconButton
          HugeIcon={Cancel01Icon}
          size={IconButtonSize.SM}
          borderLess
          className="absolute -top-2 -right-2"
          onClick={onClose}
        />
      </h1>

      <p className="text-sm font-medium text-content-400">
        You can verify by yourself or send a request to the applicant
      </p>
    </header>

    <div className="flex-grow bg-background-900 p-6 space-y-3">
      <CheckboxCard
        id="reverify_here"
        name="verification_type"
        checked={selectedReverifyOption === ReverifyFlows.ReVerifyHere}
        onChange={() => setSelectedReverifyOption(ReverifyFlows.ReVerifyHere)}
        className="!border"
        label={
          <OptionLabel
            icon={FileSyncIcon}
            title="Re-verify here with documents"
            description="Re-verify via paystubs or W2"
            selected={selectedReverifyOption === ReverifyFlows.ReVerifyHere}
          />
        }
      />

      <CheckboxCard
        id="send_request"
        name="verification_type"
        checked={selectedReverifyOption === ReverifyFlows.SendRequest}
        onChange={() => setSelectedReverifyOption(ReverifyFlows.SendRequest)}
        className="!border"
        label={
          <OptionLabel
            icon={SentIcon}
            title="Send request to the applicant"
            description="Applicant will verify via one of the available verification methods"
            selected={selectedReverifyOption === ReverifyFlows.SendRequest}
          />
        }
      />
    </div>

    <div className="px-6 py-4 border-t border-alpha-100 gap-2 flex justify-end self-end w-full">
      <Button className="w-[125px]" onClick={onClose}>
        Cancel
      </Button>

      <Button
        variant={ButtonVariant.PRIMARY}
        onClick={() => {
          setCurrentFlow(selectedReverifyOption);
        }}
      >
        Continue
      </Button>
    </div>
  </div>
);
